module.exports = __webpack_public_path__ + "media/images/home/logo-trustpilot-919154b7a9b32858142d3ea2cb6c8c41.svg";